export const BrowsePackageTourIcon = ({
  color = "#4E4E4E",
  size = 20,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${size} ${size}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.3275 13.1157C12.9341 12.6078 13.5374 12.195 14.772 12.0927C15.7316 12.0134 16.8886 12.0063 18.3544 12.0063C16.1055 8.86845 14.6574 5.89112 13.9113 2.00012H9.08899C8.6089 4.61826 7.67661 7.1328 6.3339 9.43111C11.4649 10.8087 9.64636 15.4969 5.70421 13.9606C5.79476 13.7254 5.87589 13.482 5.94762 13.2304C6.24741 13.2611 6.54306 13.3238 6.82953 13.4174C7.72203 13.7296 8.85087 13.0646 8.73094 12.1474C8.64274 11.3466 7.72908 10.881 6.93713 11.0768C6.33037 9.63572 4.09561 9.6657 3.5206 11.0538C1.05125 10.6376 1.25056 14.0029 3.60174 13.4279C3.85324 13.3453 4.11186 13.2863 4.37429 13.2516C4.27375 13.5355 4.1591 13.8142 4.03387 14.0876C3.41917 15.37 2.57033 16.5264 1.53101 17.4971C2.67396 17.707 13.7508 18.4901 10.7911 16.0278C10.4824 15.7456 10.2619 15.5763 10.2849 15.2447C10.3642 14.8037 11.3432 14.615 12.7542 14.555C13.4213 14.5399 14.0838 14.441 14.7262 14.2605C15.4194 14.0135 15.4987 13.5426 14.3275 13.1157ZM12.5055 7.31982L11.5054 6.51198L10.5001 7.31982L9.49996 6.51198L8.53515 7.30218C9.12787 5.91718 9.58794 4.47911 9.90917 3.00727H13.0999C13.4208 4.47922 13.8808 5.91733 14.4739 7.30218L13.4986 6.51198L12.5055 7.31982Z"
      fill={color}
    />
  </svg>
);
